import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plain = defineConnector({
  identifier: "plain",
  name: "Plain",
  tagLine: "Customer support platform",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://core-api\\.[^/]*\\.plain\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a machine user and API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Plain, go to **Settings → Machine Users** and create a machine user. Then click **Add API key** and select the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://core-api.uk.plain.com/graphql/v1",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ myWorkspace { id } }" }),
    }),
  },
});
